export default function setAgentLocalState(context, state) {
  context.stores.agentLocalState.set(state);
  context.stores.agentLocalStateLocal.set(state);
}
